module.exports = __webpack_public_path__ + "img/source_list2.7b4fff95.png";